export default function Alumni() {
  return (
    <div className="two-col">
      <div>
        <h2>The Cooperative</h2>
        <div className="paragraph">
          The ALAMAR cooperative is a group of extended Chase family members and close
          friends. Our mission is to carry-on the spirit of ALAMAR&apos;s design and traditional
          use as a utilitarian camp schooner for current and future generations. Whether
          learning navigation, raising a gaff, fitting a boom crutch, flushing the head,
          or swabbing the decks, adventures aboard ALAMAR provide timeless lessons about
          seamanship and life we wish to perpetuate.
        </div>
        <div className="paragraph">
          Members of the cooperative do not take wooden boat ownership lightly, nor do we
          have deep pockets. Therefore, we run a tight ship and participation is required
          by members. In addition to annual dues, there is always plenty of hard work
          required in the ship&apos;s maintenance, including annual sanding, painting, rot
          removal, rope splicing, rigging, sail mending, polishing, and fine woodworking.
        </div>
        <div className="paragraph">
          The task of maintaining a wooden boat is not easy, but the effort is easily
          forgotten the moment you set sail aboard ALAMAR. As a group, we are all very
          grateful for the opportunity to care for this boat and continue her traditions.
          We could not have a better excuse for staying close as family and friends.
        </div>
      </div>

      <div>
        <h2>Get Involved</h2>
        <div className="paragraph">
          If you love this boat, there are lots of ways to get involved!
        </div>
        <div className="paragraph">
          <strong>ALUMNI.</strong> For alumni of Alamoosok Island Camp, we can plan special
          outings, updates, day sails, and picnics.
        </div>
        <div className="paragraph">
          <strong>FAMILY.</strong> For family and friends, you can join the ship&apos;s crew and
          share in the joy and satisfaction of keeping a wooden boat in good working order.
        </div>
        <div className="paragraph">
          Please get in touch using the form on the{' '}
          <a href="/contact">Contact page</a>. We look forward to hearing from you!
        </div>
      </div>
    </div>
  )
}
